(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('UzbCardDialogController', UzbCardDialogController);

    UzbCardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'isEdit', 'UzbCard'];

    function UzbCardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, isEdit, UzbCard) {
        var vm = this;

        vm.uzbCard = entity;
        vm.isEdit = isEdit;
        vm.clear = clear;
        vm.save = save;

        if (vm.uzbCard.isBlocked === undefined) {
            vm.uzbCard.isBlocked = true;
        }
        if (vm.uzbCard.userPhone === undefined) {
            vm.uzbCard.userPhone = '73335557777'
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.uzbCard.id !== null) {
                UzbCard.update(vm.uzbCard, onSaveSuccess, onSaveError);
            } else {
                vm.uzbCard.country = 'UZB';
                if (vm.uzbCard.userPhone) {
                    vm.uzbCard.userPhone = vm.uzbCard.userPhone.replace(/\D/g, '');
                }
                UzbCard.save(vm.uzbCard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:uzbCardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
